<template>
  <b-modal
    v-model="showModal"
    :title="$t('安全验证')"
    size="md"
    centered
    hide-footer
    @hidden="onModalHidden"
  >
    <div class="tw-flex tw-justify-center tw-py-5">
      <slide-verify
        :l="42"
        :r="10"
        :w="310"
        :h="155"
        slider-text="向右滑动"
        @success="onSuccess"
        @fail="onFail"
        @refresh="onRefresh"
        :accuracy="5"
        :imgs="bgImage"
      ></slide-verify>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "verification",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      bgImage: [
        new URL("@/assets/login/verify-bg.jpg", import.meta.url).href,
        new URL("@/assets/login/verify-bg2.jpg", import.meta.url).href,
        new URL("@/assets/login/verify-bg3.jpg", import.meta.url).href,
        new URL("@/assets/login/verify-bg.jpg", import.meta.url).href,
        new URL("@/assets/login/verify-bg3.jpg", import.meta.url).href,
      ],
      isVerified: false, // 添加验证状态
      showModal: this.visible,
    };
  },
  computed: {},
  watch: {
    visible(newVal) {
      this.showModal = newVal;
    },
  },
  beforeCreate() {},
  created() {},
  methods: {
    onSuccess() {
      this.isVerified = true;
      this.$toast(this.$t("验证成功"), {
        type: "center",
        timeout: 1000,
        closeOnClick: false,
      });
      // 验证成功后通知父组件
      this.$emit("verify-success");
      // 关闭模态框
      this.showModal = false;
    },

    onFail() {
      this.isVerified = false;
      this.$toast(this.$t("验证失败，请重试"), {
        type: "center",
        timeout: 2000,
        closeOnClick: false,
      });
    },

    onRefresh() {
      this.isVerified = false;
    },
    onModalHidden() {
      // 模态框关闭时重置验证状态
      this.isVerified = false;
      this.$emit("update:visible", false);
      this.$emit("verify-cancel"); // 通知父组件验证被取消
    },
  },
};
</script>

<style lang="scss" scoped></style>
